import { NavLink } from "hooks/useCustomNavigation";

export const renderDropdownItem = (item, closeDropdown) => {
  if (item.divider || item.mobileOnly) return null;

  const handleItemClick = () => {
    if (item.onClick) item.onClick();
    closeDropdown();
  };

  const isButton = !item.path && item.onClick;

  return isButton ? (
    <button
      onClick={handleItemClick}
      className={`option ${item.border ? "border" : ""}`}
      key={item.label}
    >
      {item.label}
    </button>
  ) : (
    <NavLink
      to={item.path}
      onClick={handleItemClick}
      className={`option ${item.border ? "border" : ""}`}
      key={item.label}
    >
      {item.label}
    </NavLink>
  );
};
